export default __webpack_public_path__ + "assets/img/category-item03.png";